<script setup>
import { ref, computed } from 'vue'

import GridDetailTabs from '@/components/shared/GridDetailTabs.vue'
import BudgetDocumentRowsGrid from '@/components/accounting/BudgetDocumentRowsGrid.vue'
import CostReportRowsGrid from '@/components/accounting/CostReportRowsGrid.vue'
import InvoicesGrid from '@/components/accounting/InvoicesGrid.vue'
import ProjectTimeline from '@/components/planner/project-timeline/ProjectTimeline.vue'
import ProjectTasksGrid from '@/components/task/ProjectTasksGrid.vue'

import { useWebSiteStore } from '@/stores/web-site.store'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
})

const emit = defineEmits(['row-saved'])

const webSiteStore = useWebSiteStore()

const activeTab = ref('quote')

const project = computed(() => props.data.data)

// BudgetDocumentRowsGrid expects the master-detail model of a budget document
// (its `key` must be the budget document id). The project's budget document is
// auto-created and shares currency, listing and date range with the project.
const budgetDocumentDetailData = computed(() => ({
  ...props.data,
  key: props.data.data.budget_document?.id,
}))
</script>
<template>
  <grid-detail-tabs v-model="activeTab">
    <template #tabs>
      <q-tab name="quote" :label="$t('common.quoteRow', 2)" />
      <q-tab name="cost-report" :label="$t('common.costReportRow', 2)" />
      <q-tab v-if="webSiteStore.can(webSiteStore.permissionFlagEnum.INVOICING_VIEW)" name="invoices" :label="$t('common.invoice', 2)" />
      <q-tab name="timeline" :label="$t('menu.timeline')" />
      <q-tab name="tasks" :label="$t('common.tasks.tab')" />
    </template>
    <template #panels>
      <q-tab-panel name="quote" class="q-pa-none">
        <budget-document-rows-grid
          v-if="props.data.data.budget_document"
          :data="budgetDocumentDetailData"
          :listing="project.listing"
          show-print
          @row-saved="emit('row-saved', project.id)"
        />
      </q-tab-panel>
      <q-tab-panel name="cost-report" class="q-pa-none">
        <cost-report-rows-grid :project="props.data.data" />
      </q-tab-panel>
      <q-tab-panel v-if="webSiteStore.can(webSiteStore.permissionFlagEnum.INVOICING_VIEW)" name="invoices" class="q-pa-none">
        <invoices-grid :project-id="project.id" />
      </q-tab-panel>
      <q-tab-panel name="timeline" class="q-pa-none">
        <div class="project-timeline-tab">
          <project-timeline
            v-if="activeTab === 'timeline'"
            :project-ids="[project.id]"
            :initial-date="project.start"
          />
        </div>
      </q-tab-panel>
      <q-tab-panel name="tasks" class="q-pa-none">
        <project-tasks-grid
          v-if="activeTab === 'tasks'"
          :project-id="project.id"
        />
      </q-tab-panel>
    </template>
  </grid-detail-tabs>
</template>
<style scoped>
.project-timeline-tab {
  height: 70vh;
}
</style>
